import React from 'react';
import {
	BooleanInput,
	Datagrid,
	EditBase,
	FunctionField,
	NumberInput,
	ReferenceManyField,
	SimpleForm,
	TextField,
	TextInput,
	TopToolbar,
	useDataProvider,
	useGetOne,
	useNotify,
	useRecordContext,
} from 'react-admin';
import {
	Card,
	CardContent,
	Typography,
	Grid,
} from '@mui/material';
import { useParams } from 'react-router';
import ConfirmDeleteButton from '../../Components/Button/ConfirmDeleteBtn';

const Breadcrumb = () => {
	const record = useRecordContext();
	return (
		<TopToolbar>
			<Typography variant="subtitle1">
				Home / Plans / {record ? record.name : 'Edit'}
			</Typography>
		</TopToolbar>
	);
};

export const PlanEdit = (props: any) => {
	const notify = useNotify();
	const dataProvider = useDataProvider();
	const { id } = useParams();
	const { data: record } = useGetOne('plans', { id });

	const handleSubmit = async (data: any) => {
		try {
			await dataProvider.update('plans', {
				id: record.id,
				data,
				previousData: record,
			});
			notify('Plan updated successfully!', { type: 'success' });
		} catch (error: any) {
			notify(`Error: ${error.message}`, { type: 'error' });
		}
	};

	return (
		<EditBase {...props}>
			<React.Fragment>
				<Breadcrumb />
				<Grid container spacing={2}>
					<Grid item xs={8}>
						<Card>
							<CardContent>
								<Typography variant="h6" gutterBottom>
									Plan Features
								</Typography>
								<ReferenceManyField
									label="Features"
									reference="plan-features"
									target="plan_id"
									sort={{ field: 'id', order: 'ASC' }}
								>
									<Datagrid>
										<FunctionField
											label="Feature"
											render={(record: any) => record.feature?.name || record.featureId}
										/>
										<FunctionField
											label="Slug"
											render={(record: any) => record.feature?.slug || '-'}
										/>
										<FunctionField
											label="Type"
											render={(record: any) => record.feature?.type || '-'}
										/>
										<TextField source="value" label="Value" />
										<FunctionField
											render={(record: any) => (
												<ConfirmDeleteButton
													record={record}
													title="Remove feature"
													entity="plan-features"
													description="Remove this feature from the plan?"
													withRedirect={false}
													confirmMessage="Feature removed"
												/>
											)}
										/>
									</Datagrid>
								</ReferenceManyField>
							</CardContent>
						</Card>
					</Grid>
					<Grid item xs={4}>
						<Card>
							<CardContent>
								<Typography variant="h6" gutterBottom>
									Plan Details
								</Typography>
								<SimpleForm
									defaultValues={{ id: record?.id }}
									onSubmit={handleSubmit}
								>
									<TextInput source="id" disabled />
									<TextInput source="slug" required />
									<TextInput source="name" required />
									<TextInput source="stripeProductId" label="Stripe Product ID" />
									<NumberInput source="position" />
									<BooleanInput label="Enabled" source="enabled" />
								</SimpleForm>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</React.Fragment>
		</EditBase>
	);
};
